import styled from "@emotion/styled";

const PAGE_PADDING = "10mm";
const PAGE_FORMATS = {
  A4: {
    width: "210mm",
    height: "297mm",
  },
};

const getPageDimensions = (params: {
  format: keyof typeof PAGE_FORMATS;
  landscape: boolean;
}) => {
  const { format, landscape } = params;
  const dimensions = PAGE_FORMATS[format];
  if (landscape) {
    return {
      width: dimensions.height,
      height: dimensions.width,
    };
  }
  return dimensions;
};

// For now we only support A4 landscape, later we can extend this
export const PrintPaper = styled.div`
  width: min(87dvw, 87dvh * 3508 / 2480);
  height: min(87dvh, 87dvw * 2480 / 3508);
  aspect-ratio: 3508 / 2480;

  background: #fff;
  margin: 0 auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);

  @media print {
    width: ${getPageDimensions({ format: "A4", landscape: true }).width};
    height: ${getPageDimensions({ format: "A4", landscape: true }).height};
    aspect-ratio: auto;

    margin: 0;
    box-shadow: none;

    page-break-after: always;
    page-break-inside: avoid;

    &:last-of-type {
      page-break-after: auto;
    }
  }
`;

export const PrintPage = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: ${PAGE_PADDING};
  overflow: hidden;

  @media print {
    height: 100%;
    overflow: hidden;
  }
`;
